import { Box } from "@mui/system";



export default function Footer() {
    const developedBy = {
      backgroundColor: "#f1f6ff",
      color: "#2c4992",
      fontSize:"0.8rem",
    };
    return <Box  sx={developedBy} >Desenvolvido por R2SIS Tecnologia</Box>;
  }
  


